export default "__VITE_ASSET__db203690__"